import { ReactComponent as TwitterIcon } from "../../../icons/socials/Twitter.svg";
import { ReactComponent as FacebookIcon } from "../../../icons/socials/Facebook.svg";
import { ReactComponent as PinterestIcon } from "../../../icons/socials/Pinterest.svg";
import { ReactComponent as RedditIcon } from "../../../icons/socials/Reddit.svg";
import { ReactComponent as YoutubeIcon } from "../../../icons/socials/Youtube.svg";
import { ReactComponent as InstagramIcon } from "../../../icons/socials/Instagram.svg";

export const socials = [
  { href: "https://twitter.com/", svg: <TwitterIcon /> },
  {
    href: "https://www.facebook.com/",
    svg: <FacebookIcon />,
  },
  {
    href: "https://www.pinterest.com/",
    svg: <PinterestIcon />,
  },
  { href: "https://www.reddit.com/", svg: <RedditIcon /> },
  {
    href: "https://www.youtube.com/",
    svg: <YoutubeIcon />,
  },
  {
    href: "https://www.instagram.com/",
    svg: <InstagramIcon />,
  },
];
